import axios from "axios";
//import { render } from "@react-email/render";

let urlLogin = process.env.REACT_APP_URL_LOGIN;
let urlSaccWeb = process.env.REACT_APP_URL_SACCWEB;
let urlCCHH = process.env.REACT_APP_URL_CCHH;

export const getLogin = async (username, pass) => {
  try {
    const response = await axios({
      method: "post",
      url: urlLogin,
      data: {
        username: username,
        password: pass,
      },
    });
    return response.data[0];
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getDatosEmpleadoSITAE = async (usuarioSitae) => {
  try {
    const response = await axios.get(urlSaccWeb + "empleado/" + usuarioSitae);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

/**
 * @deprecated This function is deprecated. Use pdfHelper.generateAndDownloadPDF instead.
 * PDF generation has been moved to the frontend using @react-pdf/renderer.
 * The backend endpoint /generar-pdf has been removed.
 */
export const generarPDF = async (datos) => {
  console.warn(
    "generarPDF is deprecated. Use pdfHelper.generateAndDownloadPDF instead. " +
    "PDF generation now happens on the frontend."
  );
  throw new Error(
    "This endpoint has been removed. PDF generation is now handled on the frontend. " +
    "Please use generateAndDownloadPDF from utils/pdfHelper.js instead."
  );
};

export const getDatosOperador = async (usuario) => {
  try {
    const response = await axios.get(urlSaccWeb + "datosOperador/" + usuario);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getDatosContactos = async (usuario) => {
  try {
    const response = await axios.get(urlSaccWeb + "datosContactos/" + usuario);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getEmpleadoPic = async (codigoEmpleado) => {
  try {
    const response = await axios.get(urlCCHH + "empleadoPic/" + codigoEmpleado);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getAnioActualizado = async (codigoOperador) => {
  try {
    const response = await axios.get(urlSaccWeb + "anioActualizado/" + codigoOperador);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getAvisosAnio = async (codigoOperador, anio) => {
  try {
    const response = await axios.get(urlSaccWeb + "avisosAnio/" + codigoOperador + "/" + anio);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getServicios = async (codigoOperador) => {
  try {
    const response = await axios.get(urlSaccWeb + "listaServiciosOperador/" + codigoOperador);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getDocsAviso = async (codigoAviso) => {
  try {
    const response = await axios.get(urlSaccWeb + "documentos/" + codigoAviso);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getAvisosPendientes = async (codigoOperador, usarSufijo = true) => {
  const qs = usarSufijo ? "" : "?sufijo=0";
  try {
    const response = await axios.get(urlSaccWeb + "avisosPend/" + codigoOperador + qs);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getValidarAvisosMes = async (codigoOperador, mes, anio, servicio, usarSufijo = true) => {
  const qs = usarSufijo ? "" : "?sufijo=0";
  try {
    const response = await axios.get(
      urlSaccWeb + "avisoMesAnterior/" + codigoOperador + "/" + mes + "/" + anio + "/" + servicio + qs
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getExisteAvisoDelMes = async (codigoOperador, mes, anio, servicio, usarSufijo = true) => {
  const qs = usarSufijo ? "" : "?sufijo=0";
  try {
    const response = await axios.get(
      urlSaccWeb + "avisoMesSeleccionado/" + codigoOperador + "/" + mes + "/" + anio + "/" + servicio + qs
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getValidarAporteMes = async (codigoOperador, mes, anio, servicio, usarSufijo = true) => {
  const qs = usarSufijo ? "" : "?sufijo=0";
  try {
    const response = await axios.get(
      urlSaccWeb + "avisoAporteMesAnterior/" + codigoOperador + "/" + mes + "/" + anio + "/" + servicio + qs
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getAvisosTodosOperador = async (codigoOperador) => {
  try {
    const response = await axios.get(urlSaccWeb + "avisosTodosOperador/" + codigoOperador);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getAvisosOperador = async (codigoOperador, servicio, anio) => {
  try {
    const response = await axios.get(
      urlSaccWeb + "avisosOperador/" + codigoOperador + "/" + servicio + "/" + anio
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getAvisoInfo = async (codigoAviso) => {
  try {
    console.log('[getAvisoInfo] Fetching aviso data for:', codigoAviso);
    const response = await axios.get(
      urlSaccWeb + "avisoCobroImpresion/" + codigoAviso,
      { timeout: 10000 } // 10 second timeout to prevent infinite hangs
    );
    console.log('[getAvisoInfo] Response received:', response.data);
    return response.data;
  } catch (error) {
    console.error('[getAvisoInfo] API call failed:', error.message);
    console.error('[getAvisoInfo] Error details:', error.response?.status, error.response?.data);
    throw error;
  }
};

export const insertAvisoCobro = async (data, usarSufijo = true) => {
  const config = { "content-type": "application/json" };
  try {
    const response = await axios.post(urlSaccWeb + "guardarAvisoCobro/", { ...data, usarSufijo }, config);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const insertContactoOperador = async (data) => {
  const config = { "content-type": "application/json" };
  try {
    const response = await axios.post(urlSaccWeb + "agregarContacto/", data, config);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const updateDatosOperador = async (data) => {
  const config = { "content-type": "application/json" };
  try {
    const response = await axios.post(urlSaccWeb + "actualizarDatos/", data, config);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};
